import React from 'react';
import { Helmet } from 'react-helmet-async';

import { isServer } from 'src/shared/helpers/environment';

interface CanonicalLinkProps {
  pathname: string;
}

const makeUrl = (pathname: string) => {
  if (isServer()) return `https://hover.to${pathname}`;

  const url = new URL(pathname, window.location.origin);

  return url.href;
};

const CanonicalLink = ({ pathname }: CanonicalLinkProps) => (
  <Helmet>
    <link href={makeUrl(pathname)} rel="canonical" />
  </Helmet>
);

export { CanonicalLink };
